import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/MeterAssignmentsService.ts";
import {useMeterAssignmentsSelection} from "../hooks/useMeterAssignmentsSelection.ts";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useMeterAssignmentsSelection();
    const queryClient = useQueryClient();

    // FNP-217: the MeterAssignment table is composite-key, so delete is by
    // { customerId, sortKey } — both present on the selected row — not by id.
    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord({
                customerId: record.customerId,
                sortKey: record.sortKey,
            })));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['meterAssignments']});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};
